export function openPhone() {
    const phoneNumber = '8825791739'; 
    const url = `tel:${phoneNumber}`;
    window.open(url, '_blank');
};
export function openWhatsApp() {         
    const url = 'http://wa.aisensy.com/+918825791739';
    window.open(url, '_blank');
};
export function openMail() {
    const email = 'murugeshraja2000@gmail.com'; 
    const subject = encodeURIComponent('Subject Here'); 
    const body = encodeURIComponent('Body Here'); 
    const url = `mailto:${email}`;
    window.open(url, '_blank');
}